import { useEffect, useState } from 'react';
import { Download, Zoom, Thumbnails, Slideshow, Fullscreen, Share, Counter } from 'yet-another-react-lightbox/plugins';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ManualHeader from '../ManualHeader';
import ScrollTrigger from '@ppasmik/react-scroll-trigger';
import { Footer, Tack } from './Extra';
import { Button } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';



const SideNavigation = ({ children, club, setClub, hideSidebar }) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div id="docs-sidebar" className={"docs-sidebar " + (screenWidth >= 1200 || (screenWidth < 1200 && !hideSidebar) ? "sidebar-visible" : "sidebar-hidden")}>
            <div className="top-search-box d-lg-none p-3">
                Klubb: <SelectClub club={club} setClub={setClub} className="form-select form-select-lg mx-md-3 mx-lg-5 mb-0 d-lg-flex" />
            </div>
            <nav id="docs-nav" className="docs-nav navbar">
                <ul className="section-items list-unstyled nav flex-column pb-3">
                    {children}
                </ul>
            </nav>
        </div>);
}

const SelectClub = ({ club, setClub, className }) =>
(<select className={className} value={club} onChange={e => setClub(e.target.value)}>
    <option value="syd">Syd</option>
    <option value="sydLong">Syd en stor sida</option>
    <option value="sydKort">Work in progress för kortkurs</option>
</select>);


const Image = ({ imageSmall, image, alt = "" }) => {
    if (imageSmall == null) {
        imageSmall = image;
    }

    const [index, setIndex] = useState();
    return (
        <>
            <Lightbox
                slides={[image].map(i => ({ src: i }))}
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                counter={{ container: { style: { top: "unset", bottom: 0 } } }}
                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom, Download, Share, Counter]}
            />
            <a onClick={() => setIndex(0)}>
                <img className="figure-img img-fluid shadow rounded imgwidth"
                    src={imageSmall} alt={alt}
                />
            </a>
        </>);
}

/** <ScrollTrigger onEnter={e => setArticle(id)}> **/
const Article = ({ id, children, setArticle, setSection }) => (
    <article className="docs-article" id={id}>
        {[].concat(children).map(c => (
            <ScrollTrigger key={id + c.props.id} onEnter={e => setSection(c.props.id)}>
                {c}
            </ScrollTrigger>
        ))}
    </article>
);
/**</ScrollTrigger> **/

const Section = ({ id, children, skipBorder }) => {
    let style = {};
    if (skipBorder) {
        style = { borderBottom: '0px' };
    }
    return (
        <section className="docs-section" id={id} style={style}>
            {children}
        </section>
    );
}

const SectionHeader = ({ children }) => (<h2 className="section-heading">{children}</h2>);

const DocsHeader = ({ children, id }) => (<header id={id} className="docs-header" >{children}</header>);


const DocsHeading = ({ children, note }) => (<h1 className="docs-heading">{children} <span className="docs-time">{note}</span></h1>);

const DocsIntro = ({ children }) => (<section className="docs-intro">{children}</section>);

const Title = ({ children, icon, active, onClick }) => (
    <li className="nav-item section-title"
        onClick={() => onClick()}
    ><a className={("nav-link scrollto " + (active ? "active" : ""))} href={""}><span
        className="theme-icon-holder mr-2">
        <FontAwesomeIcon icon={icon} />
    </span>{children}</a>
    </li>
);

const Item = ({ ref, children, active, onClick }) => (
    <li className="nav-item" onClick={() => onClick()}><a className={("nav-link scrollto " + (active ? "active" : ""))} href={"#" + ref} >{children}</a></li>);


const Content = ({ children, section, article, setArticle, oneBig, club, setClub }) => {
    let [hideSidebar, setHideSidebar] = useState(true);

    children = [].concat(children).concat(Tack({ setSection: () => { }, setArticle: setArticle }));

    const navItems = [];
    const chapterIds = children.map(({ props }) => props?.id);
    const chapterTitles = children.map(({ props }) => props?.name);

    if (article == null) {
        article = chapterIds[0];
    }

    [].concat(children).forEach(({ props }, i) => {
        let v = props;
        navItems.push((<Title
            key={v.id}
            ref={v.id}
            icon={v.icon}
            active={v.id === article}
            onClick={e => setArticle(v.id)}
        //onClick={e => console.log("setting article to: ", v.id)}

        >{v.name}</Title>));
        [].concat(props.children).slice(1).forEach(({ props }) =>
            navItems.push((<Item key={v.id + props.id} ref={props.id} active={props.id === section} onClick={() => setArticle(v.id)}>{props.name}</Item>))
        );
    });

    var page = chapterIds.indexOf(article);

    return (
        <div className='bodyText'>
            <ManualHeader hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} club={club} setClub={setClub} />
            <div className="docs-wrapper">
                <SideNavigation hideSidebar={hideSidebar} club={club} setClub={setClub}>
                    {navItems}
                </SideNavigation>

                <div className="docs-content" id="mainContent">
                    <div className="container">
                        {oneBig ?
                            children :
                            (<>
                                {children[page]}
                                <Button
                                    variant="secondary"
                                    className='btn-light btn waves-effect waves-light btn-lg'
                                    style={{
                                        width: '50%',
                                        visibility: (page > 0 ? 'visible' : 'hidden'),
                                    }}
                                    onClick={e => { window.scrollTo(0, 0); setArticle(chapterIds[page - 1]) }}>
                                    Tillbaka till: {chapterTitles[page - 1]}
                                </Button>
                                <Button className='btn-auto btn-lg' style={{
                                    width: '50%',
                                    visibility: (page < (chapterIds.length - 1) ? 'visible' : 'hidden'),
                                }}
                                    onClick={e => { window.scrollTo(0, 0); setArticle(chapterIds[page + 1]); }}>Vidare till: {chapterTitles[page + 1]}</Button>
                            </>)
                        }
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export { Image, Article, Section, SectionHeader, DocsHeader, DocsHeading, DocsIntro, SideNavigation, Title, Item, Content, SelectClub };